import { ProductModel } from "@insite/client-framework/Types/ApiModels";

const getDaysToShipAttribute = (product: ProductModel | undefined): string | undefined => {
    if (!product?.attributeTypes) {
        return undefined;
    }
    const daysToShipAttr = product.attributeTypes.find(
        attr => attr?.name?.toLocaleLowerCase() === "days to ship"
    );
    return daysToShipAttr?.attributeValues?.[0]?.valueDisplay;
};

export default getDaysToShipAttribute;